import login from 'api/login.js'

import { setCookie, getCookie, checkCookie, deleteCookie } from 'common/utils.js'
import { COOKIE_USER, COOKIE_TOKEN, COOKIE_PERIOD } from 'common/const.js'
import { AUTH_SUCCESS, AUTH_FAILED, AUTH_PASSED, CLEAN_ERROR } from './mutations-types'

export default {
  loginAction ({ commit }, params) {
    return new Promise(resolve => {
      login(params.user, params.pwd)
        .then(json => {
          // Set payload to send
          const payload = {
            user: params.user,
            token: json.token
          }
          // Change global state
          commit(AUTH_SUCCESS, payload)

          // Set cookies
          setCookie(COOKIE_USER, params.user, COOKIE_PERIOD, '/')
          setCookie(COOKIE_TOKEN, json.token, COOKIE_PERIOD, '/')
          resolve()
        }).catch(() => {
          commit(AUTH_FAILED, 'Login Unauthorized')
        })
    })
  },
  checkLoginAction ({ commit }) {
    // if user cookie exists, toggle auth passed method in mutations
    if (checkCookie(COOKIE_USER) && checkCookie(COOKIE_TOKEN)) {
      const payload = {
        user: getCookie(COOKIE_USER),
        token: getCookie(COOKIE_TOKEN)
      }

      commit(AUTH_PASSED, payload)
    }
  },
  logoutAction ({ commit }) {
    deleteCookie(COOKIE_USER, '/')
    deleteCookie(COOKIE_TOKEN, '/')
    commit(AUTH_FAILED, '')
  },
  cleanError ({ commit }) {
    commit(CLEAN_ERROR)
  }
}
